import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const DeckBuilder = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my deck builder business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps deck builder businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for deck builder businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most deck builder businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my deck builder business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like deck builder. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Deck Builder - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Deck Builder CRM", url: "/industries/deck-builder" }
  ];

  const industryData = {
    name: 'Deck Building',
    title: 'Convert More Estimates & Build Projects Year-Round',
    subtitle: 'Automate estimate follow-ups, showcase completed projects, and book spring builds in winter',
    icon: '🏗️',
    challenges: [
      'Estimates go cold during planning phase',
      'Weather limits construction season',
      'Hard to showcase quality of work',
      'Permit process delays projects',
      'One-time customers don\'t refer'
    ],
    solutions: [
      'Long-term estimate nurture campaigns',
      'Off-season booking incentives',
      'Digital portfolio showcasing',
      'Permit tracking automation',
      'Referral program management'
    ],
    features: [
      'Customer CRM with project tracking',
      'Estimate follow-up automation',
      'Before/after photo galleries',
      'Design visualization tools',
      'Permit documentation',
      'Material cost tracking',
      'Project timeline management',
      'Review automation'
    ],
    results: [
      '60% more estimates convert',
      'Book winter for spring construction',
      '50% revenue from referrals',
      '£8.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Deck Builder UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for deck builder businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for deck builder UK, deck builder business software, deck builder customer management, deck builder lead generation UK"
        url="/industries/deck-builder"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default DeckBuilder;